import { useState } from 'react';

export interface AddModelPayload {
  model_name: string;
  deployment: string;
  cost_prompt: number;
  cost_completion: number;
}

const useAddModel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const API_URL = process.env.REACT_APP_ADD_MODEL_API || '';

  const addModel = async (payload: AddModelPayload): Promise<boolean> => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const text = await response.text();
        setError(text || `Request failed with status ${response.status}`);
        return false;
      }
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to add model';
      setError(message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { addModel, loading, error };
};

export default useAddModel;
